var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000034080739244969383590000005011362225808595630_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0.4C36.8,0,47.7,11.1,47.7,24c-0.2,13.1-10.8,23.6-23.8,23.6c-13-0.2-23.5-10.8-23.5-23.8C0.4,11.1,11.2,0,24,0.4z  M24,2.6c-11.8,0.3-21.2,9-21.3,21.3C2.5,35.4,11.6,45,23.2,45.2c0.3,0,0.5,0,0.8,0c11.6,0.2,21.1-9,21.3-20.5c0-0.2,0-0.5,0-0.7 C45.3,12.2,36.4,3,24,2.6L24,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26.4v6.3c-0.1,1.2,0.5,2.3,1.6,2.8c0.8,0.2,1.2,1,1,1.8c-0.2,0.8-1,1.3-1.8,1.2h-6.4c-0.9,0-1.6-0.3-1.8-1.2 c-0.2-0.8,0.2-1.5,1-1.8c1-0.4,1.7-1.5,1.6-2.6v-8.6c0.1-1.2-0.5-2.3-1.6-2.8c-0.8-0.2-1.2-1-1-1.8c0.2-0.8,1-1.3,1.8-1.2 c1.4,0,2.9,0,4.3,0c1,0,1.3,0.4,1.3,1.4C26.4,22,26.4,24.2,26.4,26.4L26.4,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7,9.5c1.6,0,2.8,1.3,2.7,2.9c0,1.6-1.3,2.8-2.9,2.7c-1.5,0-2.7-1.2-2.7-2.7C20.8,10.8,22.1,9.5,23.7,9.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.94037b12fc63280cc1e19bc1c33c584d.svg";
export { ForwardRef as ReactComponent };